// src/hooks/usePageContent.js
import { useState } from "react";
import {
    getActiveBank,
    getSingleBank
} from "../services/bankService";

const useBank = () => {
    const [status, setStatus] = useState("idle"); // idle | loading | done | error
    const [error, setError] = useState("");
    const [data, setData] = useState([]);
    const [single, setSingle] = useState(null);

    const fetchActiveBank = async () => {
        setStatus("loading");
        setError("");

        try {
            const response = await getActiveBank();

            if (response?.status !== "Error") {
                setData(response.data ?? response); // depending on API shape
                setStatus("done");
            } else {
                setStatus("error");
                setError(response?.message || "Something went wrong");
            }
        } catch (err) {
            setStatus("error");
            setError(err?.message || "Something went wrong");
        }
    };

    const fetchSingleBank = async (bankId) => {
        setStatus("loading");
        setError("");
    
        try {
          const response = await getSingleBank(bankId);
    
          if (response?.status !== "Error") {
            setSingle(response.data ?? response); // depending on API shape
            setStatus("done");
          } else {
            setStatus("error");
            setError(response?.message || "Something went wrong");
          }
        } catch (err) {
          setStatus("error");
          setError(err?.message || "Something went wrong");
        }
      };

    const resetStatus = () => {
        setStatus("idle");
        setError("");
    };

    return {
        fetchActiveBank,
        fetchSingleBank,
        data,
        single,
        status,
        error,
        resetStatus,
    };
};

export default useBank;
